export default __webpack_public_path__ + "static/media/topup_banner.30f0b876.jpg";